import { Component, EventEmitter, Input, Output } from "@angular/core"
import { MapService } from "src/app/services/map.service"

@Component({
	selector: "app-result-modal",
	templateUrl: "./result-modal.component.html",
	styleUrls: ["./result-modal.component.scss"]
})
export class ResultModalComponent {
	@Input() show_close = true
	@Input() p2p: any
	@Input() position1: any
	@Input() position2: any
	@Input() errorText: string
	@Input() errorTitle: string
	@Input() isBea: boolean
	@Input() salesforceSent: boolean = false
	@Input() userData: any
	@Input() showSpinner: any
	@Output() sendToSalesforce = new EventEmitter()

	constructor(public mapService: MapService) {}

	get canViewSfLink() {
		if (
			this.userData.type !== "Prospect" &&
			(this.userData.roles.includes("ROLE_BEA") || this.userData.roles.includes("ROLE_P2P_ATTIVA"))
		) {
			return true
		}
		return false
	}
}
